module.exports = __webpack_public_path__ + "static/media/Legend-Key-No-BTSC.430ca7f9.jpg";